import mixpanelUtils from '@/utils/mixpanel.utils'

const setPresentation = (state, payload) => {
  if (!payload.language) {
    payload.language = 'en'
  }
  state.presentation = payload
}

const updatePresentation = (state, payload) => {
  if (!payload.language) {
    payload.language = 'en'
  } else if (!payload.fontFamily) {
    payload.fontFamily = 'nunito'
  }
  state.presentation = { ...state.presentation, ...payload }
}

const unsetPresentation = () => {
  mixpanelUtils.unregisterPresentationContext()
}

const setIsCreatingNewPresentation = (state, payload) => {
  state.isCreatingNewPresentation = payload
}

const setMorePresentationsLoading = (state, payload) => {
  state.loaders.morePresentationsLoading = payload
}

export default {
  setPresentation,
  updatePresentation,
  unsetPresentation,
  setIsCreatingNewPresentation,
  setMorePresentationsLoading,
}
